export const MODULE_GET = '@MODULE_GET'
export const MODULE_GET_SUCCESS = '@MODULE_GET_SUCCESS'
export const MODULE_GET_FAILURE = '@MODULE_GET_FAILURE'

export default {
  MODULE_GET,
  MODULE_GET_SUCCESS,
  MODULE_GET_FAILURE
}
